import React, { useState } from 'react';
import { Box, Container } from '@mui/material';
import Projects from './components/Projects';
import ProfileSection from './components/ProfileSection';

function App() {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleModalStateChange = (isOpen: boolean) => {
    setIsModalOpen(isOpen);
  };

  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        background: `
          radial-gradient(ellipse at center top, rgba(124, 58, 237, 0.06) 0%, transparent 50%),
          radial-gradient(ellipse at bottom left, rgba(20, 184, 166, 0.06) 0%, transparent 50%),
          linear-gradient(180deg, #1e293b 0%, #0f172a 100%)
        `,
        display: 'flex',
        overflow: isModalOpen ? 'hidden' : 'auto',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            repeating-linear-gradient(
              90deg,
              transparent,
              transparent 2px,
              rgba(37, 99, 235, 0.02) 2px,
              rgba(37, 99, 235, 0.02) 4px
            )
          `,
          opacity: 0.3,
          pointerEvents: 'none',
        },
      }}
      role="main"
    >
      <Container maxWidth="xl" sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' }, // Vertical sur mobile, horizontal sur desktop
        gap: { xs: 2, md: 4 }, 
        justifyContent: { xs: 'flex-start', md: 'space-between' }, 
        position: 'relative', 
        zIndex: 1, 
        width: '100%',
        minHeight: '100vh',
        alignItems: { xs: 'stretch', md: 'center' },
        py: { xs: 2, md: 0 }, // Padding vertical sur mobile
      }}>
        
        {/* Section présentation à gauche */}
        <ProfileSection />

        {/* Section projets à droite */}
        <Box sx={{ 
          width: { 
            xs: '100%', 
            md: 'calc(100% - 350px - 32px)' 
          },
          maxWidth: { xs: '100%', md: '900px' },
          height: { xs: 'auto', md: '80vh' }, // Hauteur limitée pour permettre l'overflow interne
          flex: { xs: '1', md: 'unset' },
        }}>
          <Projects onModalStateChange={handleModalStateChange} />
        </Box>

      </Container>
    </Box>
  );
}

export default App;